
  <sm-title-bar  pageTitle="Messages"></sm-title-bar>


  
  
  
  <div class="chat-container" >
    <mat-card class="sidebar">
      <div class="search_bart">
      <mat-form-field  appearance="outline">
        <mat-label>Search by name</mat-label>
        <input matInput>
      </mat-form-field>
    </div>
      <mat-list style="padding: 0px 0px;
      overflow: auto;
      height: 70vh;"> 
          <!-- <div matLine>Name</div> -->
          <div *ngFor="let thread of chatThreads | messageFilter: searchKey" (click)="selectThread(thread)" class="chatxx chatTCLS scrollbox-content" [ngClass]="{'selected': thread.isSelected == 1}"  >
   
            <div class="ultra_sectionmk">
            <div class="left_cat" style="padding-top: 5px;padding-right: 0px;">
              <img [src]="thread.senderInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 50px; width: 50px; border-radius: 50%;" alt="" *ngIf="thread.isSender == 0">
              <img [src]="thread.receiverInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 50px; width: 50px;border-radius: 50%;" alt="" *ngIf="thread.isSender == 1">
            </div>
            <div class="right_chatx" style="padding-right: 0px;">
              <div class="thread" style="display: flex;align-items: center;width: 100%;width: 200px;">
                <span style="flex: 1; font-size: 1rem;font-weight: normal;" *ngIf="thread.isSender == 0">{{ thread.senderInfo.name }}</span>
                <span style="flex: 1; font-size: 1rem;font-weight: normal;" *ngIf="thread.isSender == 1">{{ thread.receiverInfo.name }}</span>
              </div>
              <div style=" width: 200px;">
                <p style="margin: -5px 0 0px;font-weight: normal; color:#5e5e5e">(with {{thread.entity_name}})</p>
              </div>
              <div style="padding: 2px 1px 15px;color: #888;width: 200px;">
              {{thread.lastMessage.length > 40 ? thread.lastMessage.substring(0,40) + "..." : thread.lastMessage}}
              </div>
            </div>
           
          </div>
          <div class="lats_date_name">
            <p style="margin: 0; color: #888; font-size: 11px; ">{{thread.lastMTime}}</p>
            <div class="msg_status" *ngIf="thread.read_status > 0"></div>
          </div>
          </div>
        
      </mat-list>
    </mat-card>
  
    <mat-card class="chat-window" *ngIf="selectedThread.length > 0 && !chatLoader">
      <div class="chat-header mesheader">
        <div class="header" style="height: 52px;padding-top: 6px;">
          <span *ngIf="(myProfileHash == selectedThread[0].senderInfo.hash_id && myProfileHash != selectedThread[0].receiverInfo.hash_id) || (myProfileHash != selectedThread[0].senderInfo.hash_id && myProfileHash == selectedThread[0].receiverInfo.hash_id)">
            <img *ngIf="myProfileHash == selectedThread[0].senderInfo.hash_id" [src]="selectedThread[0].receiverInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 40px; width: 40px; border-radius: 50%;     object-fit: cover;" alt="">
            <img *ngIf="myProfileHash == selectedThread[0].receiverInfo.hash_id" [src]="selectedThread[0].senderInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 40px; width: 40px; border-radius: 50%;     object-fit: cover;" alt="">

          </span>
          <span *ngIf="myProfileHash == selectedThread[0].senderInfo.hash_id && myProfileHash == selectedThread[0].receiverInfo.hash_id">
            <img [src]="selectedThread[0].senderInfo.imgThumbUrl" onerror="this.src='../../../../assets/images/user-avatar.svg'" style="height: 40px; width: 40px; border-radius: 50%;     object-fit: cover;" alt="">
          </span>
          <span *ngIf="(myProfileHash == selectedThread[0].senderInfo.hash_id && myProfileHash != selectedThread[0].receiverInfo.hash_id) || (myProfileHash != selectedThread[0].senderInfo.hash_id && myProfileHash == selectedThread[0].receiverInfo.hash_id)">

            <span style="margin-left: 10px;position: relative;top: -10px;font-weight: normal;font-size: 16px;color: #333; "*ngIf="myProfileHash == selectedThread[0].senderInfo.hash_id"> {{ selectedThread[0].receiverInfo.name }}</span>
            <span style="margin-left: 10px;position: relative;top: -10px;font-weight: normal;font-size: 16px;color: #333;"*ngIf="myProfileHash == selectedThread[0].receiverInfo.hash_id"> {{ selectedThread[0].senderInfo.name }}</span>
          </span>
          <span *ngIf="myProfileHash == selectedThread[0].senderInfo.hash_id && myProfileHash == selectedThread[0].receiverInfo.hash_id">
            <span style="margin-left: 10px;position: relative;top: -10px;font-weight: normal;font-size: 16px;"*ngIf="myProfileHash == selectedThread[0].receiverInfo.hash_id"> {{ selectedThread[0].senderInfo.name }}</span>
          </span>
            <p style="font-size: 14px;position: relative;top: -19px;left: 54px;font-weight: 500;width: fit-content;color: #888;">(with {{sThread.entity_name}})</p>
        </div>
        <div class="refres_btn_srd">
          <button class="refres_btn_srd" mat-icon-button aria-label="Refresh" (click)="refresh()">
            <mat-icon>refresh</mat-icon>
          </button>
          
        </div>
      </div>
      <div class="chat-body">
        <div class="chat_sectionm">
        <div>
          <div class="bns_pliud_aas" >
            <div class="asde" >
                <div class="scrollbox hrklm" id="divExample" #scrollableDiv>
                    <div class="chat-history scrollbox-content" >
                        <ul>
                            <li class="clearfix" *ngFor="let message of selectedThread; let i=index;"> 
                              <!-- message i received -->
                                <div class="bgmes_thy" *ngIf="message.iSent == 0">
                                    <div class="message my-message" style="position: relative;" [ngClass]="{'custcls2': message.status != 1}">
                                      
                                        <div class="myDIV" [ngStyle]="{'margin-top': message.status == 1 ? '8px' : '0px'}">
                                          <p *ngIf="message.status == 1" class="bnstextspace">{{message.message}}</p>
                                          <p *ngIf="message.status != 1" class="bnstextspace">This message was deleted</p>
                                        </div>
                                        <div style="text-align: right;
                                        font-size: 12px;
                                        color: #282828;
                                        padding: 25px 0px 0px 0px;">
                                          <span>{{message.creationTime | date:'dd-MM-yyyy, h:mm a':'UTC+0530'}}
                                          </span>
                                        </div>
                                    </div>
                                </div>
                                <!-- message i sent -->
                                <div class="bgmes_thy" *ngIf="message.iSent == 1">
                                  <div class="message other-message float-right" style="position: relative;" [ngClass]="{'custcls': message.status != 1}"  (mouseenter)="onMouseEnter(message)"
                                  (mouseleave)="onMouseLeave(message)">
                                    <button
                                    *ngIf="message.status == 1"
                                    style="top: -6px;
                                    right: 0px;
                                    position: absolute;
                                    color: #222 !important;
                                    "
                                     [style.display]="(message.showmenu && message.showmenu == true)  ? 'block' : 'none'"
                                    mat-icon-button
                                    [matMenuTriggerFor]="menuopt"
                                    class="profile_button"
                                    class="opt"
                                  >
                                    <mat-icon class="material-icons-outlined" style="font-size: 20px; color: #222222;"
                                      >more_horiz</mat-icon
                                    >
                                  </button>
                                  <mat-menu #menuopt="matMenu">
                                    <button mat-menu-item (click)="deleteMessage(message.subMsgHash)">
                                      <span class="menu_text">Delete</span>
                                    </button>
                                  </mat-menu>
                                      <div class="myDIV" [ngStyle]="{'margin-top': message.status == 1 ? '8px' : '0px'}">
                                        <p *ngIf="message.status == 1" class="bnstextspace">{{message.message}}</p>
                                        <p *ngIf="message.status != 1" class="bnstextspace">This message was deleted</p>
                                      </div>
                                      <div style="text-align: right;
                                      font-size: 12px;
                                      color: #282828;
                                      padding: 25px 0px 0px 0px; ">
                                        <span>{{message.creationTime | date:'dd-MM-yyyy, h:mm a':'UTC+0530'}}</span>
                                      </div>
                                  </div>
                              </div>
                            </li>

                        

                            <div class="sd_mgr"></div>
                        </ul>
                    </div>
                </div>
            </div>
          
        </div>




        </div>
      </div>
      </div>
      <mat-form-field class="chat-footer" appearance="outline" style="width: 98%;">
        <textarea (keydown.enter)="sendMessage()"  placeholder="Write something" matInput [disabled]="textAreaDisabled" [(ngModel)]="message" style="height: 18px;resize: none;"></textarea>
        <button mat-icon-button matSuffix (click)="sendMessage()" *ngIf="!textAreaDisabled">
          <mat-icon>send</mat-icon>
        </button>
        <button mat-icon-button matSuffix  *ngIf="textAreaDisabled">
          <mat-spinner [diameter]="30" style="position: relative;
          
          top: 2px;  stroke: #fff;"></mat-spinner>
        </button>
      </mat-form-field>
    </mat-card>

      <div class="right-panel" *ngIf="selectedThread.length == 0 || chatLoader" style=" overflow-x: hidden; overflow-y: hidden;">
        <div class="chat-header">
          <div class="header" style="height: 52px;padding-top: 17px;">
            <p style="font-size: 16px; position: relative; top: 0; left: 20px; font-weight: normal; width: fit-content;
            color: #a8a8a8;">No conversation selected</p>
          </div>
        </div>
        <div class="bns_pliud_aas" style="    padding-top: 0px;">
          <div class="asde" style="background: #eee;">
              <div class="" style=" overflow-y: auto;overflow-x: hidden" id="divExample" >
                  <div class="chat-history scrollbox-content">
                    <div style="text-align: center; height: 58vh;padding-top: 13%;" *ngIf="!chatLoader">
                      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M510.156 401.843 480.419 315.3c14.334-29.302 21.909-61.89 21.96-94.679.088-57.013-21.97-110.92-62.112-151.79-40.15-40.878-93.652-63.889-150.652-64.792-59.105-.934-114.661 21.548-156.428 63.314-40.274 40.273-62.612 93.366-63.319 150.102-39.694 29.886-63.123 76.481-63.046 126.25.037 23.29 5.279 46.441 15.212 67.376L1.551 470.689c-3.521 10.247-.949 21.373 6.713 29.035 5.392 5.393 12.501 8.264 19.812 8.264 3.076 0 6.188-.508 9.223-1.551l59.609-20.483c20.935 9.933 44.086 15.175 67.376 15.212h.248c50.51-.002 97.46-24.035 127.237-64.702 30.987-.816 61.646-8.317 89.363-21.876l86.544 29.738a33.696 33.696 0 0 0 10.959 1.843c8.688 0 17.136-3.412 23.545-9.822 9.104-9.105 12.16-22.326 7.976-34.504zM164.53 470.69h-.199c-20.614-.031-41.085-5.113-59.196-14.695a15.244 15.244 0 0 0-12.078-.942l-61.123 21.003 21.003-61.122a15.24 15.24 0 0 0-.942-12.078c-9.582-18.112-14.664-38.582-14.696-59.197-.051-33.159 12.848-64.588 35.405-88.122 7.368 44.916 28.775 86.306 61.957 118.898 32.937 32.351 74.339 52.949 119.011 59.683-23.588 23.249-55.384 36.572-89.142 36.572zm316.098-55.893c-.867.867-1.895 1.103-3.051.705l-92.648-31.836a15.232 15.232 0 0 0-12.077.942c-26.453 13.994-56.345 21.416-86.447 21.462h-.288c-100.863 0-184.176-81.934-185.774-182.773-.805-50.785 18.513-98.514 54.394-134.395 35.881-35.881 83.618-55.192 134.396-54.392 100.936 1.601 182.926 85.068 182.77 186.063-.047 30.102-7.468 59.995-21.461 86.446a15.24 15.24 0 0 0-.942 12.078l31.835 92.648c.397 1.16.159 2.187-.707 3.052z" fill="#b0b0b0" opacity="1" data-original="#000000" class=""></path><path d="M376.892 139.512h-181.56c-8.416 0-15.238 6.823-15.238 15.238 0 8.416 6.823 15.238 15.238 15.238h181.56c8.416 0 15.238-6.823 15.238-15.238s-6.822-15.238-15.238-15.238zM376.892 202.183h-181.56c-8.416 0-15.238 6.823-15.238 15.238s6.823 15.238 15.238 15.238h181.56c8.416 0 15.238-6.823 15.238-15.238s-6.822-15.238-15.238-15.238zM307.004 264.852H195.331c-8.416 0-15.238 6.823-15.238 15.238 0 8.416 6.823 15.238 15.238 15.238h111.672c8.416 0 15.238-6.823 15.238-15.238s-6.821-15.238-15.237-15.238z" fill="#b0b0b0" opacity="1" data-original="#000000" class=""></path></g></svg>
                      <h3 style="margin-top: 18px;color: #a8a8a8; font-size: 16px; margin-bottom: 2px; line-height: 24px;">The messages will appear here once you select a thread from the left side.</h3>
                   <h3 style=" margin-top: 0px; color: #a8a8a8;  font-size: 16px; line-height: 24px;">If the left side panel shows nothing, that means you have not started messaging yet.</h3>
                </div>
                    <div style="text-align: center;height: 58vh;  padding-top: 24%;" *ngIf="chatLoader">
                      <svg version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" style=" width: 130px;
                      height: 130px;
                      margin: 20px;
                      display:inline-block;">
                      <circle fill="#f2124d" stroke="none" cx="6" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite"
                          begin="0.1"/>    
                      </circle>
                      <circle fill="#f2124d" stroke="none" cx="26" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite" 
                          begin="0.2"/>       
                      </circle>
                      <circle fill="#f2124d" stroke="none" cx="46" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite" 
                          begin="0.3"/>     
                      </circle>
                      <circle fill="#f2124d" stroke="none" cx="66" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite" 
                          begin="0.3"/>     
                      </circle>
                      <circle fill="#f2124d" stroke="none" cx="86" cy="50" r="4">
                        <animate
                          attributeName="opacity"
                          dur="1s"
                          values="0;1;0"
                          repeatCount="indefinite" 
                          begin="0.3"/>     
                      </circle>
                    </svg>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="" style="background-color: #fff;padding: 0px 8px;">   
        <mat-form-field class="chat-footer" appearance="outline" style="width: 98%;margin-bottom: 0px;">
          <textarea (keyup.enter)="sendMessage()" [disabled]="true" placeholder="Write something" matInput style="height: 18px;resize: none;"></textarea>
        </mat-form-field>   
      </div>



    
      </div>
   
   
   
  </div>
  
  
